// @flow
import React, { Component } from 'react';


export default class SocialLink extends Component {

    render () {
        return (
            <div
                className="ln-social-share">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.behance.net/kasia410f"
                    className="icon-behance">Laura Nor on Behance</a>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://pl.pinterest.com/kasiapilipionek/"
                    className="icon-pinterest">Laura Nor on Pinterest</a>

                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.instagram.com/lauranor_/"
                    className="icon-instagram">Laura Nor on Instagram</a>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/SocialLink/SocialLink.js